var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('resize-observer',{on:{"notify":_vm.fit}}),_c('div',{ref:"root",staticClass:"root",domProps:{"innerHTML":_vm._s(_vm.html)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }